<!-- src/components/TaskList.vue -->
<template>
  <div class="w-11/12 slide-content">
    <h2 class="text-xl font-bold mb-4">{{ title }} 
      <button class="btn bg-green-500 text-white px-3 py-1 rounded hover:bg-green-600" @click="toggleAddNewTask">
        <MdiIcon name="plus" v-if="!addNewTask" class="w-5 h-5" />
        <MdiIcon name="minus" v-if="addNewTask" class="w-5 h-5" />
      </button>
      <button class="btn bg-blue-500 text-white px-3 py-1 rounded hover:bg-green-600" @click="toggleCompleted">
        <MdiIcon v-if="!showCompleted" name="mdiCheckboxBlank" class="w-5 h-5" />
        <MdiIcon v-if="showCompleted" name="mdiCheckboxMarked" class="w-5 h-5" />
      </button>
    </h2>
    <ul class="space-y-4 task-list" @touchstart="handleTouchStart" @touchend="handleTouchEnd" @touchmove="handleTouchMove">
      <AddTask class="mb-4" v-if="addNewTask" :fileName="fileName" @taskCreated="handleTaskCreated"/>
      <TaskItem v-for="task in filteredTasks" :key="task.lineNumber" :task="task" /> 
    </ul>
  </div>
</template>

<script>
import { ref, computed } from 'vue';

import TaskItem from './TaskItem.vue'
import AddTask from './AddTask.vue'
import MdiIcon from './MdiIcon.vue';

export default {
  name: 'TaskList',
  components: {
    TaskItem,
    AddTask,
    MdiIcon
  },
  props: {
    tasks: Array,
    fileName: String
  },

  setup(props, { emit }) {
    const addNewTask = ref(false)
    const showCompleted = ref(false)
    const file = ''
    const startScrolPosition = ref({ x: null, y: null })
    const scrollDir = ref(null)
    const toggleAddNewTask = () => {
      addNewTask.value = !addNewTask.value
    }
    

    const handleTaskCreated = () => {
      addNewTask.value = false
      emit('taskCreated')
    }

    // Set title by filename from props and remove the file extension
    const title = props.fileName.replace(/\.[^/.]+$/, '')

    const toggleCompleted = () => {
      showCompleted.value = !showCompleted.value
      console.log('showCompleted', showCompleted.value)
    }

    const filteredTasks = computed(() => {
      return props.tasks.filter(task => showCompleted.value || !task.completed)
    })

    // const handleScroll = (event) => {
    //   console.log('scrolling')
    //   const element = event.target
    //   if (element.scrollTop > 0 || element.scrollTop + element.clientHeight < element.scrollHeight) {
    //     emit('scrolling', true)
    //   } else {
    //     emit('scrolling', false)
    //   }
    // }

    const handleTouchStart = (event) => {
      startScrolPosition.value = {x: event.touches[0].clientX, y: event.touches[0].clientY}
    }
    const handleTouchEnd = () => {
      startScrolPosition.value = {x:null, y:null}
      scrollDir.value = null
      // emit('scrolling', false)
    }
    const handleTouchMove = (event) => {
      // event.preventDefault()
      // event.stopPropagation()
      
      if (scrollDir.value !== null) {
        if (scrollDir.value === 'y') {
          event.stopPropagation()
        }
        return
      }
      
      // Check if the user is scrolling by checking the touch event
      const position = {x: Math.abs(event.touches[0].clientX - startScrolPosition.value.x), y: Math.abs(event.touches[0].clientY - startScrolPosition.value.y)}
      
      if (position.x > 5 || position.y > 5) {
        scrollDir.value = position.x > position.y ? 'x' : 'y'
        if (scrollDir.value === 'y') {
          // emit('scrolling', true)
        }
      }
    }


    return {
      addNewTask,
      toggleAddNewTask,
      file,
      title,
      handleTaskCreated,
      showCompleted,
      toggleCompleted,
      filteredTasks,
      
      handleTouchStart,
      handleTouchEnd,
      handleTouchMove

    }
  }
}
</script>

<style scoped>
.task-list {
  /* Max height is vh - 100px */
  max-height: calc(100vh - 150px);
  overflow-y: auto;
}
/* Add your styles here */
</style>